let domain = "https://podeli-api.dev.co-dd.dev";
let cdnUrl = "https://cdn.pdeli.ru";
const isCdnEnabled = false;

if (
  window.location.host == "podeli.ru" ||
  window.location.host == "pdeli.ru" ||
  window.location.host == "192.168.1.76:3000" ||
  window.location.host == "localhost:3000"
) {
  domain = "https://podeli-api.co-dd.ru";
}
let isCatalog = false;

const CATALOG_TYPES = {
  CATALOG: "catalog",
  APP: "app",
  AM: "am",
  AO: "ao",
};
let catalogType = CATALOG_TYPES.APP;

if (
  window.location.pathname === "/catalog" ||
  window.location.pathname === "/test_catalog"
) {
  isCatalog = true;
  catalogType = CATALOG_TYPES.CATALOG;
} else if (
  window.location.pathname === "/app_shop_am" ||
  window.location.pathname === "/test_app_shop_am"
) {
  catalogType = CATALOG_TYPES.AM;
} else if (
  window.location.pathname === "/app_shop_ao" ||
  window.location.pathname === "/test_app_shop_ao"
) {
  catalogType = CATALOG_TYPES.AO;
}
const prepareUtmLink = (link, hide_utm) => {
  let symbol = link.indexOf("?") === -1 ? "?" : "&";
  let utm =
    symbol +
    "utm_source=podeli.ru&utm_medium=banner&utm_campaign=" +
    (isCatalog ? "podeli_web" : "podeli_app");
  return link + (!hide_utm ? utm : "");
};

export { domain, isCatalog, catalogType, CATALOG_TYPES, prepareUtmLink };

export const getUrlImage = (props) => {
  let result = "";
  if (props.data && props.data.attributes && props.data.attributes.url) {
    if (isCdnEnabled && props.data.attributes.url.indexOf("/uploads") === 0) {
      result = cdnUrl + props.data.attributes.url.replace("/uploads", "");
    } else if (props.data.attributes.url.indexOf("/") === 0) {
      result = domain + props.data.attributes.url;
    } else {
      result = props.data.attributes.url.replace(
        "https://podeli.storage.yandexcloud.net",
        cdnUrl
      );
    }
  }
  return result;
};

export const targetMetrick = (target) => {
  if (window.ym) {
    window.ym(93798687, "reachGoal", target);
  }
};

export const getLinkTheme = (url, params) => {
  let theme = "";
  if (params && params !== "podeli") {
    theme = "?theme=" + params;
  }

  return url + theme;
};
export const shuffle = (array) => {
  return array.sort(() => Math.random() - 0.5);
};

export const shuffleArrayExceptFirstThree = (array) => {
  // Проверка, что массив имеет более трех элементов
  if (array.length <= 3) {
    return array; // Нечего перемешивать
  }

  // Разделение массива на три части: первые три элемента и оставшаяся часть
  const firstThree = array.slice(0, 5);
  const rest = array.slice(5);

  // Функция для перемешивания массива с использованием алгоритма Фишера-Йетса
  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]]; // Swap elements
    }
    return array;
  }

  // Перемешиваем оставшуюся часть массива
  const shuffledRest = shuffle(rest);

  // Соединяем первые три элемента и перемешанную оставшуюся часть
  return firstThree.concat(shuffledRest);
};
